/* eslint-disable camelcase */
import React from 'react';
import { TextInputAutocomplete } from 'playup-web-core';

import { getRegionDetails, getRegionPredictions, useGoogleMapsPlaces } from './googleAPI';

const GeoRegion: React.FC<Props> = ({
	label,
	address,
	countryCode,
	name,
	placeholder = 'Start typing to search...',
	selectedRegion,
	onUserSelectsRegion,
}) => {
	const debounceTimerRef = React.useRef<number>();

	useGoogleMapsPlaces();

	const handleQueryElements = React.useCallback(
		async (query: string) => {
			// lodash's debounce doesn't play well with promises so I had to do it manually
			return new Promise<
				Array<{
					label: string;
					id: string;
					element: any;
				}>
			>((resolve) => {
				if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);

				debounceTimerRef.current = window.setTimeout(() => {
					resolve(getRegionPredictions(query, countryCode));
				}, 300);
			});
		},
		[countryCode]
	);

	const handleSelectElement = (result) => {
		if (result?.id)
			getRegionDetails(result.id).then((region) => {
				if (region && region.displayName && region.latitude && region.longitude) {
					onUserSelectsRegion(region.displayName, region.latitude, region.longitude);
				}
			});
	};

	return (
		<div>
			<TextInputAutocomplete
				label={label}
				name={name}
				placeholder={placeholder}
				queryElements={handleQueryElements}
				onSelectElement={handleSelectElement}
				initialValue={selectedRegion}
			></TextInputAutocomplete>
		</div>
	);
};

export default GeoRegion;

interface Props {
	address?: UserAddress;
	countryCode: string;
	label: string;
	name: string;
	selectedRegion: string;
	placeholder?: string;
	onUserSelectsRegion: (displayName: string, latitude: number, longitude: number) => void;
}
